/* Pied de page commun (home et pages VRAM). Feuille propre au composant : elle suit
   SiteFooter partout où il est rendu, sans dépendre du thème de la page. */
.site-footer {
  background: #090e11;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding: 40px 24px calc(28px + env(safe-area-inset-bottom, 0px));
  color: rgba(244, 247, 255, 0.68);
  font-family: "Sora", "Sora Fallback", "Space Grotesk", sans-serif;
  font-size: 14px;
}

.site-footer-inner,
.site-footer-bottom {
  width: min(1160px, 100%);
  margin: 0 auto;
}

.site-footer-inner {
  display: grid;
  gap: 28px 32px;
  grid-template-columns: repeat(auto-fit, minmax(min(180px, 100%), 1fr));
}

.site-footer p {
  margin: 0;
  font-size: inherit;
  line-height: 1.6;
}

.site-footer-name {
  margin-bottom: 6px !important;
  font-family: "Space Grotesk", "Space Grotesk Fallback", "Sora", sans-serif;
  font-size: 18px !important;
  font-weight: 600;
  color: #f4f7ff;
}

.site-footer-title {
  margin-bottom: 10px !important;
  font-size: 12px !important;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(244, 247, 255, 0.55);
}

.site-footer ul {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.site-footer a {
  color: rgba(244, 247, 255, 0.82);
  text-decoration: none;
}

.site-footer a:hover {
  color: #49f2c2;
}

.site-footer-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px 24px;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 13px;
  color: rgba(244, 247, 255, 0.55);
}

@media (pointer: coarse) {
  .site-footer ul {
    gap: 0;
  }

  .site-footer li a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
  }
}

/* Mobile : accordéon. La version en colonnes est masquée, celle en <details> affichée. */
.site-footer-mobile {
  display: none;
}

@media (max-width: 639px) {
  .site-footer {
    padding: 8px 20px calc(24px + env(safe-area-inset-bottom, 0px));
  }
  .site-footer-inner {
    display: none;
  }
  .site-footer-mobile {
    display: block;
    width: 100%;
  }
  .site-footer-bottom {
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
    padding-top: 0;
    border-top: 0;
    font-size: 12px;
  }
}

.site-footer-acc {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.site-footer-acc summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  list-style: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: rgba(244, 247, 255, 0.85);
}

.site-footer-acc summary::-webkit-details-marker {
  display: none;
}

.site-footer-acc summary svg {
  color: rgba(244, 247, 255, 0.5);
  transition: transform 0.2s ease;
}

.site-footer-acc[open] summary svg {
  transform: rotate(180deg);
}

.site-footer-acc ul {
  padding-bottom: 8px;
}

@media (prefers-reduced-motion: reduce) {
  .site-footer-acc summary svg {
    transition: none;
  }
}

/* Bouton « Pause background animation » : écrit comme un lien du pied de page. Les règles
   :hover/:focus-visible doublent la classe pour passer devant le style global des boutons. */
.site-footer-motion,
.site-footer-motion:hover {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  box-shadow: none;
  transform: none;
  font: inherit;
  color: rgba(244, 247, 255, 0.82);
  cursor: pointer;
  transition: color 0.15s ease;
}

.site-footer-motion:hover {
  color: #49f2c2;
}

.site-footer-motion:focus-visible {
  outline: 2px solid #49f2c2;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .site-footer-motion-wrap {
    display: none;
  }
}
